import React from 'react'
import './NotFound.scss'

const NotFound = () => (
  <div className='not-found'>
    <h2>
        404
    </h2>
    <span>
        <i class="fas fa-sad-tear"></i>
    </span>
    <p>page not found</p>
  </div>       
)

export default NotFound
